import styled, { keyframes } from 'styled-components';

const spin = keyframes`
	from { transform: rotate(0deg); }
	to   { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
	from { opacity: 0; transform: translateY(-4px) scale(0.98); }
	to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const SpinningIcon = styled.span`
	display: inline-flex;
	animation: ${spin} 0.8s linear infinite;
`;

export const Container = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 2px;
`;

export const MenuButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 6px;
	border-radius: var(--punchup-radius-md);
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background 0.15s, color 0.15s;
	color: var(--punchup-color-text-muted);

	&:hover:not(:disabled) {
		color: var(--punchup-color-text-body);
		background: var(--punchup-color-hover-bg);
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	svg circle {
		fill: currentColor;
	}
`;

export const PortalDropdown = styled.div`
	position: fixed;
	min-width: 224px;
	background: var(--punchup-color-bg);
	color: var(--punchup-color-text-body);
	border: 1px solid var(--punchup-color-border);
	border-radius: var(--punchup-radius-md);
	box-shadow: var(--punchup-shadow-md);
	z-index: 9999;
	padding: 4px;
	animation: ${fadeIn} 0.12s ease-out;
	font-family: var(--punchup-font-family);
	transform-origin: top right;
`;

export const ItemRow = styled.div`
	display: flex;
	align-items: stretch;
	gap: 2px;
`;

export const Item = styled.button`
	flex: 1;
	min-width: 0;
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px 8px;
	display: flex;
	align-items: center;
	gap: 10px;
	color: var(--punchup-color-text-body);
	font-size: var(--punchup-font-size-sm);
	font-weight: 500;
	font-family: inherit;
	text-align: left;
	border-radius: var(--punchup-radius-sm);
	transition: background 0.12s, color 0.12s;

	&:hover:not(:disabled) {
		background: var(--punchup-color-surface);
	}

	&:disabled {
		color: var(--punchup-color-text-muted);
		cursor: not-allowed;
	}
`;

export const ItemDestructive = styled(Item)`
	color: var(--punchup-color-destructive);

	&:hover:not(:disabled) {
		background: var(--punchup-color-danger-bg);
		color: var(--punchup-color-destructive);
	}
`;

export const ItemIcon = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
`;

export const ItemLabel = styled.span`
	flex: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const PinToggle = styled.button<{ active: boolean }>`
	background: none;
	border: none;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	border-radius: var(--punchup-radius-sm);
	color: ${(p) => (p.active ? 'var(--punchup-color-primary)' : 'var(--punchup-color-text-muted)')};
	opacity: ${(p) => (p.active ? 1 : 0)};
	transition: opacity 0.12s, background 0.12s, color 0.12s;

	${ItemRow}:hover & {
		opacity: ${(p) => (p.active ? 1 : 0.55)};
	}

	&:hover {
		background: var(--punchup-color-hover-bg);
		opacity: 1;
		color: ${(p) => (p.active ? 'var(--punchup-color-primary)' : 'var(--punchup-color-text-body)')};
	}

	&:focus-visible {
		opacity: 1;
		outline: 2px solid var(--punchup-color-primary);
		outline-offset: 1px;
	}
`;

export const Separator = styled.div`
	height: 1px;
	background: var(--punchup-color-border);
	margin: 4px 0;
`;
